import { FloorPlanMaterial } from "@faro-lotv/lotv";
import { Mesh, PlaneGeometry } from "three";

/** The 2D photo object with createView to support split screen rendering */
export class Photo2DObject extends Mesh<PlaneGeometry, FloorPlanMaterial> {
  /** @returns a new Photo2DObject referencing but not owning the same plane geometry */
  createView(): Photo2DObject {
    return new Photo2DObject(this.geometry, this.material);
  }
}
